import { Component, ViewEncapsulation } from '@angular/core';

import { DialogRef, ModalComponent } from 'angular2-modal';

import { MessageModalPreset } from './presets/message-modal-preset';

export interface BSMessageModalButtonHandler {
  (cmp: ModalComponent<MessageModalPreset>, $event: MouseEvent): void;
}

/**
 * Interface for button definition
 */
export interface BSMessageModalButtonConfig {
  cssClass: string;
  caption: string;
  onClick: BSMessageModalButtonHandler;
}
export class BSMessageModalTitle {
public context: MessageModalPreset;
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<MessageModalPreset>) {
    this.context = dialog.context;
  }
/**
 * @return {?}
 */
get titleHtml(): number {
    return this.context.titleHtml ? 1 : 0;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'modal-title',
  encapsulation: ViewEncapsulation.None,
  template: `<div [ngClass]="context.headerClass" [ngSwitch]="titleHtml">
      <button *ngIf="context.showClose" type="button" class="close" 
              aria-label="Close" (click)="dialog.dismiss()">
          <span aria-hidden="true">×</span>
      </button>
      <div *ngSwitchCase="1" [innerHtml]="context.titleHtml"></div>
      <h3 *ngSwitchDefault class="modal-title">{{context.title}}</h3>
 </div>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function BSMessageModalTitle_tsickle_Closure_declarations() {
/** @type {?} */
BSMessageModalTitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BSMessageModalTitle.ctorParameters;
/** @type {?} */
BSMessageModalTitle.prototype.context;
/** @type {?} */
BSMessageModalTitle.prototype.dialog;
}

export class BSMessageModalBody {
public context: MessageModalPreset;
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<MessageModalPreset>) {
    this.context = dialog.context;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'modal-body',
  encapsulation: ViewEncapsulation.None,
  styles: [`.form-group {
    margin-top: 10px;
  }`],
  template: `<div [ngClass]="context.bodyClass"> 
    <div [innerHtml]="context.message"></div>
      <div *ngIf="context.showInput" class="form-group">
        <input autofocus #input
            name="bootstrap" 
            type="text" 
            class="form-control"
            [value]="context.defaultValue"
            (change)="context.defaultValue = input.value"  
            placeholder="{{context.placeholder}}">
      </div>
    </div>
`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function BSMessageModalBody_tsickle_Closure_declarations() {
/** @type {?} */
BSMessageModalBody.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BSMessageModalBody.ctorParameters;
/** @type {?} */
BSMessageModalBody.prototype.context;
/** @type {?} */
BSMessageModalBody.prototype.dialog;
}

/**
 * Represents the modal footer for storing buttons.
 */
export class BSModalFooter {
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<MessageModalPreset>) {
  }
/**
 * @param {?} btn
 * @param {?} $event
 * @return {?}
 */
onClick(btn: BSMessageModalButtonConfig, $event: MouseEvent) {
    $event.stopPropagation();
    btn.onClick(this, $event);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'modal-footer',
  encapsulation: ViewEncapsulation.None,
  template: `<div [ngClass]="dialog.context.footerClass">
    <button *ngFor="let btn of dialog.context.buttons;"
            [ngClass]="btn.cssClass"
            (click)="onClick(btn, $event)">{{btn.caption}}</button>
</div>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function BSModalFooter_tsickle_Closure_declarations() {
/** @type {?} */
BSModalFooter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BSModalFooter.ctorParameters;
/** @type {?} */
BSModalFooter.prototype.dialog;
}

/**
 * A Component representing a generic bootstrap modal content element.
 * 
 * By configuring a MessageModalContext instance you can:
 * 
 *  Header:
 *      - Set header container class (default: modal-header)
 *      - Set title text (enclosed in H3 element)
 *      - Set title html (overrides text)
 * 
 *  Body:
 *      - Set body container class.  (default: modal-body)
 *      - Set body container HTML.
 * 
 *  Footer:
 *      - Set footer class.  (default: modal-footer)
 *      - Set button configuration (from 0 to n)
 */
export class BSMessageModal implements ModalComponent<MessageModalPreset> {
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<MessageModalPreset>) {
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'modal-content',
  encapsulation: ViewEncapsulation.None,
  template: `<modal-title></modal-title><modal-body></modal-body><modal-footer></modal-footer>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function BSMessageModal_tsickle_Closure_declarations() {
/** @type {?} */
BSMessageModal.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BSMessageModal.ctorParameters;
/** @type {?} */
BSMessageModal.prototype.dialog;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
